import { createAsyncThunk } from '@reduxjs/toolkit';
import { requestIpData } from 'store/api/ip-api/ip.service';
import { IpResponseSchema, TIpData } from 'store/api/ip-api/types/ip-response-data.interface';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';

export const fetchIpData = createAsyncThunk(
  'ip/fetch',
  async (): Promise<TIpData> => await requestWithZodSchema(requestIpData, IpResponseSchema),
);
